import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from './index';
import { setNotification } from './NotificationSlice';
import walletConnector from '../features/wallet-connector';
import { getUserPhrase, makeBlockChainSignin, setBlockChainAddress, setIsComingFrmoBlockchain } from './RegisterSlice';

const initialState = {
    address: '',
    chainId: '',
    connected: false,
};

const WalletSlice = createSlice({
    name: 'wallet',
    initialState,
    reducers: {
        setWallet: (state, action: PayloadAction<{ address: string; chainId?: string }>) => {
            state.address = action.payload.address;
            state.connected = Boolean(action.payload.address);
            if (action.payload.chainId) state.chainId = action.payload.chainId;
        },
        setChainId: (state, action: PayloadAction<string>) => {
            state.chainId = action.payload;
        },
        disconnectWallet: (state) => {
            state.address = '';
            state.chainId = '';
            state.connected = false;
        },
    }
});

export const { setWallet, setChainId, disconnectWallet } = WalletSlice.actions;

export const connectWallet = (): AppThunk<Promise<string | undefined>> => async (dispatch) => {
    try {
        const { address, chainId } = await walletConnector.connect();
        dispatch(setWallet({ address, chainId }));
        await dispatch( setIsComingFrmoBlockchain(true));
        await dispatch( setBlockChainAddress(address));
        await dispatch( getUserPhrase(address) );
        await dispatch( makeBlockChainSignin() );
        return address;
    } catch (err: any) {
        console.error(err);
        dispatch(setNotification({
            status: true,
            title: "Erro ao conectar carteira",
            msg: err?.message || "Não foi possível conectar com a MetaMask.",
            class: "error",
            position: "top"
        }));
    }
};

export const restoreWallet = (): AppThunk<Promise<void>> => async (dispatch) => {
    if (!walletConnector.isMetaMaskInstalled()) return;
    try {
        const accounts = await walletConnector.getWallets();
        if (accounts.length > 0) dispatch(setWallet({ address: accounts[0] }));
    } catch (err) {
        console.error(err);
    }
};

// selectors
export const getWalletAddress = (state: RootState) => state.wallet.address;
export const getWalletChainId = (state: RootState) => state.wallet.chainId;
export const isWalletConnected = (state: RootState) => state.wallet.connected;

// EXPORT DEFAULT
export default WalletSlice.reducer;
